import styled from 'styled-components';
import { TabContainer, StyledTabButton } from 'components/ui/Tabs/Tabs.styles';

const BookingTypesContainer = styled(TabContainer)`
  width: 100%;
`;
const BookingTypeButton = StyledTabButton;

const BookingTypes = styled.div`
  display: flex;
  align-items: center;
`;

const BookingTypesHeader = styled.h4`
  margin: 0 2rem 0 0;
`;

export { BookingTypesHeader, BookingTypesContainer, BookingTypeButton, BookingTypes };
